import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarClock } from "lucide-react";

interface Props {
  onClick: () => void;
}

export function BookDemoFab({ onClick }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const ratio = (h.scrollTop + window.innerHeight) / h.scrollHeight;
      setVisible(window.scrollY > 600 && ratio < 0.92);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.85, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.85, y: 20 }}
          transition={{ type: "spring", stiffness: 280, damping: 24 }}
          onClick={onClick}
          aria-label="Запросить demo"
          className="glow-cta fixed bottom-5 right-5 z-40 hidden md:flex items-center gap-2 rounded-2xl bg-gradient-to-r from-primary to-accent px-5 py-3 text-sm font-semibold text-primary-foreground shadow-xl ring-1 ring-primary/40 transition-transform hover:scale-105"
        >
          <CalendarClock className="h-4 w-4" />
          Demo за 15 минут
        </motion.button>
      )}
    </AnimatePresence>
  );
}
